import React, { useState, Fragment, useEffect } from 'react';
import {
    Card,
    CardBody,
    Button,
    Label,
    CustomInput,
    Row
} from 'reactstrap';
import Select from 'react-select';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { gAPI_AllServices } from '../../../../../../constants/APIs';

const guestLifeCycleList = [
    { label: 'Pre Booking', value: 'Pre Booking' },
    { label: 'Pre Check-in', value: 'Pre Check-in' },
    { label: 'At Property', value: 'At Property' },
    { label: 'After Check-out', value: 'After Check-out' },
    { label: 'Member Specific', value: 'Member Specific' }
];
export default function StandaloneServiceAddons({
    pageSettings,
    integrationProperties,
    saveIntegration,
}) {
    const [lifeCycle, setLifeCycle] = useState(guestLifeCycleList);
    const [membershipGroupData, setMembershipGroupData] = useState([]);
    const [selectedMembershipGroup, setSelectedMembershipGroup] = useState([]);
    const [isMembershipGroup, setIsMembershipGroup] = useState(false);
    const [inputData, setInputData] = useState({
        guestLifeCycle: [],
        membershipGroup: []
    });
    useEffect(() => {
        if (integrationProperties !== undefined) {
            let data = {
                languageCode: "en",
                propertyId: integrationProperties
            };
            AxiosAPI({
                method: 'post',
                url: `${gAPI_AllServices}`,
                data: data
            }).then((res) => {
                const serviceData = res.data.services.filter((item) => item.status === "Active");
                let member = [];
                serviceData.map((m) => {
                    if (m.membershipGroup !== null && m.membershipGroup.length > 0)
                        m.membershipGroup.map((n, i) => {
                            member.push({ label: n, value: n, key: member.length });
                        })
                });
                setMembershipGroupData(member);
                if (pageSettings !== undefined && pageSettings !== null) {
                    let selectedGuestLifeCycle = [];
                    if (pageSettings.guestLifeCycle !== null && pageSettings.guestLifeCycle.length > 0) {
                        selectedGuestLifeCycle = lifeCycle.map((elem) => {
                            var exist = pageSettings.guestLifeCycle.filter((item) => item === elem.value);
                            if (exist.length > 0) {
                                elem.checked = true;
                            } else {
                                elem.checked = false;
                            }
                            return {
                                ...elem,
                            };
                        });
                        setLifeCycle(selectedGuestLifeCycle);
                    }
                    const membershipGroup = selectedGuestLifeCycle.filter(i => i.checked === true && i.value === "Member Specific");
                    setIsMembershipGroup(membershipGroup.length > 0 ? true : false);
                    var selectedMemmbershipgroup = [];
                    if (pageSettings.membershipGroup != null && pageSettings.membershipGroup.length > 0) {
                        pageSettings.membershipGroup.map((item, i) => {
                            selectedMemmbershipgroup.push(member.filter((cat) => cat.value === item)[0]);
                        });
                    }
                    setSelectedMembershipGroup(selectedMemmbershipgroup);
                    setInputData({
                        guestLifeCycle: pageSettings.guestLifeCycle,
                        membershipGroup: pageSettings.membershipGroup
                    })
                }
            }).catch((err) => console.log('err', err));
        }
    }, [pageSettings, integrationProperties]);

    const handleSave = () => {
        let setting = pageSettings;
        setting.guestLifeCycle = inputData.guestLifeCycle;
        setting.membershipGroup = inputData.membershipGroup;
        saveIntegration({
            pageSettings: setting
        });
    };

    const handleLifeCycleChange = (e) => {
        const values = lifeCycle.map((elem) => {
            if (elem.value === e.target.value) {
                elem.checked = !elem.checked;
            }
            return {
                ...elem,
            };
        });
        setLifeCycle(values);
        const lifecycleArr = values.filter((elem) => elem.checked === true).map((elem) => elem.value);
        setIsMembershipGroup(lifecycleArr.includes("Member Specific"));
        setInputData({
            ...inputData,
            guestLifeCycle: lifecycleArr,
        });
    };
    const handleChangeMultiMembershipGroup = (selectedMembershipGroup) => {
        setSelectedMembershipGroup(selectedMembershipGroup);
        const membershipGroupArr = selectedMembershipGroup.map((elem) => elem.value);
        setInputData({
            ...inputData,
            membershipGroup: membershipGroupArr,
        });
    };
    return (
        <Card className="mb-4">
            <CardBody>
                <div className="text-center">
                    <h6>Guest Services & Add-on’s</h6>
                    <Separator className="mb-3" />
                    <Row>
                        <Colxx sm={12} className="text-left">
                            <Label className="mt-3">Guest Lifecycle Applicability</Label>
                            <div className="row">
                                {lifeCycle.map((item, index) => (
                                    <div className="col-md-6" key={index}>
                                        <CustomInput
                                            type="checkbox"
                                            id={'guestLifeCycle' + index}
                                            value={item.value}
                                            label={item.label}
                                            checked={item.checked}
                                            onChange={handleLifeCycleChange}
                                        />
                                    </div>
                                ))}
                            </div>
                        </Colxx>
                        {isMembershipGroup && (
                            <Colxx sm={12} className="text-left">
                                <Fragment>
                                    <Label className="mt-3">Membership Group</Label>
                                    <Select
                                        components={{ Input: CustomSelectInput }}
                                        className="react-select"
                                        classNamePrefix="react-select"
                                        isMulti={true}
                                        name="form-field-name"
                                        value={selectedMembershipGroup}
                                        onChange={handleChangeMultiMembershipGroup}
                                        options={membershipGroupData}
                                    />
                                </Fragment>
                            </Colxx>
                        )}
                    </Row>
                    <Separator className="mt-2 mb-2" />
                    <Button
                        size="xs"
                        color="primary"
                        className="ml-2"

                        style={{ marginTop: '20px', display: 'inline-block' }}
                        onClick={() => handleSave()}
                    >
                        Save
                    </Button>
                </div>
            </CardBody>
        </Card>);
}
